export const printContent = ({ content, cssString = "", disclaimer }) => {
  // Create a hidden iframe
  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.fontFamily = "'Roboto', Helvetica, Arial, sans-serif";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  document.body.appendChild(iframe);

  // Load the print content into the iframe
  const iframeDoc = iframe.contentWindow.document;
  iframeDoc.open();
  iframeDoc.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Print</title>
        <style>
          ${cssString}
          .watermark {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            pointer-events: none;
            z-index: 9999;
            font-family: 'Roboto', Helvetica, Arial, sans-serif !important;
            font-size: 130px;
            color: rgba(0, 0, 0, 0.1);
            transform: rotate(-45deg);
          }
        </style>
      </head>
      <body>
        <div class="markdown">
          ${content}
        </div>
        <div class="watermark">www.lawgpt.pk</div>
        <div class="disclaimer" style="position: fixed; bottom: 15px; width: 100%; text-align: center; font-size: 12px; color: #555; font-family: 'Roboto', Helvetica, Arial, sans-serif;">
    ${disclaimer ?? ""}
  </div>
      </body>
    </html>
  `);
  iframeDoc.close();

  // Trigger the print dialog
  iframe.contentWindow.focus();
  iframe.contentWindow.print();

  // Ensure the iframe is cleared and removed after printing
  iframe.contentWindow.onafterprint = () => {
    iframeDoc.body.innerHTML = ""; // Clear content
    document.body.removeChild(iframe); // Remove the iframe
  };
};
